import * as types from './constants';

// Get Top Performers
export const getTopPerformersRequest = data => (
  { type: types.GET_TOP_PERFORMERS_REQUEST, payload: data }
);

export const getTopPerformersDone = data => (
  { type: types.GET_TOP_PERFORMERS_DONE, payload: data }
);

export const getTopPerformersFailed = errors => (
  { type: types.GET_TOP_PERFORMERS_FAILED, payload: errors }
);

export const getTopPerformersReset = () => (
  { type: types.GET_TOP_PERFORMERS_RESET }
);